var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0848 2.57941V6.37153C14.0848 6.76197 14.4013 7.07849 14.7917 7.07849C15.1822 7.07849 15.4987 6.76197 15.4987 6.37153V0.872973C15.4987 0.482531 15.1822 0.166016 14.7917 0.166016H9.29317C8.90273 0.166016 8.58622 0.482531 8.58622 0.872973C8.58622 1.26342 8.90273 1.57993 9.29317 1.57993H13.0847L7.22196 7.44265C6.94587 7.71874 6.94587 8.16636 7.22196 8.44244C7.49804 8.71853 7.94566 8.71853 8.22175 8.44244L14.0848 2.57941Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.40186 2.75819C2.49072 2.75819 1.75229 3.49662 1.75229 4.40776V12.2628C1.75229 13.174 2.49072 13.9124 3.40186 13.9124H11.2569C12.1681 13.9124 12.9065 13.174 12.9065 12.2628V8.3353C12.9065 7.94486 13.223 7.62835 13.6135 7.62835C14.0039 7.62835 14.3204 7.94486 14.3204 8.3353V12.2628C14.3204 13.9549 12.949 15.3263 11.2569 15.3263H3.40186C1.70983 15.3263 0.338379 13.9549 0.338379 12.2628V4.40776C0.338379 2.71573 1.70983 1.34428 3.40186 1.34428H7.3294C7.71985 1.34428 8.03636 1.66079 8.03636 2.05124C8.03636 2.44168 7.71985 2.75819 7.3294 2.75819H3.40186Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.af9996a2a640a66f77f1359a29741895.svg";
export { ForwardRef as ReactComponent };